import { NgModule } from '@angular/core';
import {
  BookerAirComponent,
  bookerAirContainerResolver,
} from '@dynamic-components/booker-v2/bookers/air/booker-air';
import { BookerAirFormComponent } from '@dynamic-components/booker-v2/bookers/air/booker-air-form';
import { BookerAirMultiCityModule } from '@dynamic-components/booker-v2/bookers/air/booker-air-multi-city/booker-air-multi-city.module';
import { BookerAirStandaloneComponent } from '@dynamic-components/booker-v2/bookers/air/booker-air-standalone/booker-air-standalone.component';
import { CityPairSelectorModule } from '@dynamic-components/booker-v2/shared/city-pair-selector';
import { CitySelectorModule } from '@dynamic-components/booker-v2/shared/city-selector';
import { DateRangePickerModule } from '@dynamic-components/booker-v2/shared/date-range-picker/date-range-picker.module';
import { PromoCodeV2Module } from '@dynamic-components/booker-v2/shared/promo-code-v2';
import { LetDirective, PushPipe } from '@ngrx/component';
import { BookerModule } from '@shared/booker/booker.module';
import { DOTDebugContentModule } from '@shared/debug-content';
import { DotBackgroundOverlayModule } from '@shared/dot-background-overlay/dot-background-overlay.module';
import { StaticBookerPodModule } from '@shared/static-booker-pod';
import { SkeletonModule } from '@skeleton/skeleton.module';
import {
  JbFormFieldContainerModule,
  JbSrOnlyModule,
} from 'jb-component-library';

import { TravelerSelectorModule } from './shared/traveler-selector/traveler-selector.module';

const MODULES = [
  BookerModule,
  TravelerSelectorModule,
  CityPairSelectorModule,
  DateRangePickerModule,
  PromoCodeV2Module,
  BookerAirMultiCityModule,
  DotBackgroundOverlayModule,
  CitySelectorModule,
  JbFormFieldContainerModule,
  JbSrOnlyModule,
  StaticBookerPodModule,
  DOTDebugContentModule,
  SkeletonModule,
  LetDirective,
  PushPipe,
];

const DECLARATIONS = [
  BookerAirStandaloneComponent,
  BookerAirComponent,
  BookerAirFormComponent,
];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  exports: [...DECLARATIONS],
})
export class BookerAirModule {
  static entry = BookerAirComponent;
  static componentDataResolver = bookerAirContainerResolver;
}
